import ApiBuilder from './ApiBuilder'
const { API } = ApiBuilder

const getAllApplications = () => {
  return API.get(`/api/application/app-release-details`)
}

const getApplicationById = (appId) => {
  return API.get(`/api/application/${appId}`)
}

const updateClientSecret = (releaseId, clientId, secretValue) => {
  return API.post(`/api/application/${releaseId}/shared-secret/${clientId}`, secretValue)
}

const generateClientCertificate = (releaseId, clientId, password) => {
  return API.post(`/api/application/${releaseId}/certificate/${clientId}`, password, { responseType: 'blob' })
}

const startSyncApplictionsJob = (platformCode) => {
  return API.post(`/api/Job/LICENSE_PRODUCTS_SYNC`, platformCode)
}

export default {
  getAllApplications,
  getApplicationById,
  updateClientSecret,
  generateClientCertificate,
  startSyncApplictionsJob
}